import { Fragment, useState } from "react";
import { Modal, Button, Spin, Result, Upload, message, notification } from "antd";
import { Searcher, TableAntd } from "../../components/commons";
// import { Redirect } from "react-router-dom";
import { useQuery } from "react-query";
import { useAuth } from "../../utils/useAuth";
import { getAll } from "../../api/bdPosibleParticipante";
import { createColumns } from "./formatTable";
import AddUser from "./components/AddBDPosibleParticipante";
import EditRegister from "./components/EditBDPosibleParticipante";
import DeleteRegister from "./components/DeleteBDPosibleParticipante";
import { UserAddOutlined, FileExcelOutlined, UploadOutlined } from "@ant-design/icons";
import { BASE_PATH, API_VERSION } from "../../api/api";
import { ACCESS_TOKEN } from "../../api/auth";
import { DATE_LIKE_NAME } from "../../utils/functions";
import {
  downloadExcelFileBDParticipantes,
  downloadExcelPlantillaBDParticipantes
} from "../../api/bdPosibleParticipante";

function Participantes() {
  const { isAdmin } = useAuth();
  const [isUploading, setIsUploading] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [modalContent, setModalContent] = useState(null);
  const [filterTable, setFilterTable] = useState(null);
  const [page, setPage] = useState(1);
  const [modalTitle, setModalTitle] = useState("");
  const { data, isError, error, isLoading } = useQuery("bdposibles-participantes", getAll);

  // ------ Show modal add record -----------
  const showAddModal = () => {
    setIsModalVisible(true);
    setModalTitle("Agregar posible participante");
    setModalContent(<AddUser closeModal={closeModal} />);
  };

  const closeModal = () => {
    setIsModalVisible(false);
  };

  // ------ Show modal edit record -----------
  const showEditModal = (record) => {
    setIsModalVisible(true); //mostrar modal
    setModalTitle("Editar posible participante");
    setModalContent(
      <EditRegister record={record} closeModal={closeModal} setModalContent={setModalContent} />
    );
  };

  // ------ Show modal delete record -----------
  const showDeleteModal = (record) => {
    setIsModalVisible(true);
    setModalTitle("Eliminar posible participante");
    setModalContent(<DeleteRegister record={record} closeModal={closeModal} />);
  };

  if (isLoading) {
    return <Spin tip="Cargando" className="w-full py-60" />;
  }

  if (isError) {
    return (
      <Result
        status="500"
        title="Algo salió mal"
        subTitle={error.message}
        extra={
          <Button onClick={() => window.location.reload()} type="primary">
            Recargar
          </Button>
        }
      />
    );
  }

  // ------ Formato para que se muestre en la tabla ------
  const columnsToTable = createColumns(page, showEditModal, showDeleteModal, isAdmin);

  // ------ Search filter ------
  /**
   * search
   * @param {String} value
   * Busca por cualquier valor de la columna
   * fuentes:
   * https://codesandbox.io/s/basic-usage-ant-design-demo-2swep?file=/index.js
   * https://github.com/ant-design/ant-design/issues/22969#issuecomment-611738230
   */
  const search = (value) => {
    const tempFilterTable = data.payload.filter((o) =>
      Object.keys(o).some((k) => String(o[k]).toLowerCase().includes(value.toLowerCase()))
    );

    setFilterTable(tempFilterTable);
  };

  //  --------------- BDPosibleParticipante ---------------

  const uploadBDParticipantesProps = {
    name: "mas_participante",
    action: `${BASE_PATH}/${API_VERSION}/mas_participantes/upload`,
    headers: { authorization: ACCESS_TOKEN },
    onChange(info) {
      if (info.file.status !== "uploading") {
        setIsUploading(true);
      }
      if (info.file.status === "done") {
        setIsUploading(false);
        window.location.reload();
        message.success(`${info.file.name} subido correctamente`);
      } else if (info.file.status === "error") {
        notification.error({
          message: "Operación fallida",
          description: info.file.response.message
        });

        setIsUploading(false);

        // message.error(`${info.file.name} falló en subir.`);
      }
    }
  };

  // ------------- Descarga data excel -------------
  const downloadBDParticipantesExcel = async () => {
    const blob = await downloadExcelFileBDParticipantes();

    // 2. Create blob link to download
    const url = window.URL.createObjectURL(new Blob([blob]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `mas_participante-${DATE_LIKE_NAME}.xlsx`);
    // 3. Append to html page
    document.body.appendChild(link);
    // 4. Force download
    link.click();
    // 5. Clean up and remove the link
    link.parentNode.removeChild(link);
  };

  // ------------- Descarga plantilla -------------
  const downloadPlantillaBDParticipantesExel = async () => {
    const blob = await downloadExcelPlantillaBDParticipantes();

    // 2. Create blob link to download
    const url = window.URL.createObjectURL(new Blob([blob]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `mas_participante-plantilla-${DATE_LIKE_NAME}.xlsx`);
    // 3. Append to html page
    document.body.appendChild(link);
    // 4. Force download
    link.click();
    // 5. Clean up and remove the link
    link.parentNode.removeChild(link);
  };

  return (
    <Fragment>
      <div className="my-4 gap-4 mr-4 flex flex-col flex-wrap  md:flex-row justify-between md:flex-nowrap">
        <span className="font-bold text-lg text-blue-500">
          ({data.payload.length || 0}) BASE DE DATOS DE POSIBLES PARTICIPANTES
        </span>
        {isAdmin && (
          <div className="flex gap-4 flex-col flex-wrap  md:flex-row md:flex-nowrap">
            <Button
              onClick={showAddModal}
              icon={<UserAddOutlined />}
              className="focus:outline-none text-white text-sm h-9 px-5 rounded-md bg-blue-500 hover:bg-blue-600 hover:shadow-lg"
            >
              Nuevo
            </Button>
            <Button
              onClick={downloadBDParticipantesExcel}
              icon={<FileExcelOutlined />}
              className="focus:outline-none text-white text-sm h-9 px-5 rounded-md bg-green-500 hover:bg-green-600 hover:shadow-lg"
            >
              Descarga Excel
            </Button>
            <Button
              onClick={downloadPlantillaBDParticipantesExel}
              icon={<FileExcelOutlined />}
              className="focus:outline-none text-white text-sm h-9 px-5 rounded-md bg-green-500 hover:bg-green-600 hover:shadow-lg"
            >
              Descargar plantilla
            </Button>
            <Upload showUploadList={false} {...uploadBDParticipantesProps} accept=".xlsx">
              <Button
                loading={isUploading}
                icon={<UploadOutlined />}
                className="text-white rounded-md text-sm h-9 px-5 bg-yellow-500 hover:bg-yellow-600 hover:shadow-lg"
              >
                Subir Excel
              </Button>
            </Upload>
          </div>
        )}
      </div>

      <Searcher onSearch={search} placeholder="Busca algún posible participante" />

      <TableAntd
        columns={columnsToTable}
        dataSource={filterTable == null ? data.payload : filterTable}
        setPage={setPage}
      />

      <Modal
        title={modalTitle}
        visible={isModalVisible}
        footer={null}
        onCancel={closeModal}
        destroyOnClose
        maskClosable={false}
      >
        {modalContent}
      </Modal>
    </Fragment>
  );
}

export default Participantes;
